import {
  BellOutlined,
  SafetyCertificateOutlined,
  SketchOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const FEATURE_ITEMS = [
  {
    image: '3d6f4605f3bfef923337fb17d415fd94.png',
    badgeKey: 'coupon.features.items.autoSave.badge',
    titleKey: 'coupon.features.items.autoSave.title',
    descriptionKey: 'coupon.features.items.autoSave.description',
    highlightKey: 'coupon.features.items.autoSave.highlight',
    highlightIcon: SafetyCertificateOutlined,
  },
  {
    image: '6d3a8d64d7061f00104e46705f1be163.png',
    badgeKey: 'coupon.features.items.smartReminder.badge',
    titleKey: 'coupon.features.items.smartReminder.title',
    descriptionKey: 'coupon.features.items.smartReminder.description',
    highlightKey: 'coupon.features.items.smartReminder.highlight',
    highlightIcon: BellOutlined,
  },
  {
    image: 'fe1bc5417f259deea03ab65bf1a57482.png',
    badgeKey: 'coupon.features.items.instantUse.badge',
    titleKey: 'coupon.features.items.instantUse.title',
    descriptionKey: 'coupon.features.items.instantUse.description',
    highlightKey: 'coupon.features.items.instantUse.highlight',
    highlightIcon: ThunderboltOutlined,
  },
  {
    image: '9dfb53963c067c4daad99d4863309160.png',
    badgeKey: 'coupon.features.items.exclusiveBenefits.badge',
    titleKey: 'coupon.features.items.exclusiveBenefits.title',
    descriptionKey: 'coupon.features.items.exclusiveBenefits.description',
    highlightKey: 'coupon.features.items.exclusiveBenefits.highlight',
    highlightIcon: SketchOutlined,
  },
] as const

const ServiceFeatures = () => (
  <section
    className="w-full py-[80px]"
    style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #F5FAFF 100%)' }}
  >
    <div className="mx-auto w-[1200px]">
      <div className="flex flex-col items-center">
        <LangText
          lngKey="coupon.features.title"
          className="text-[36px] font-bold leading-[50px] text-[#000000]"
        />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-primary" />
      </div>

      <div className="mt-[48px] grid grid-cols-4 gap-[28px]">
        {FEATURE_ITEMS.map((item) => {
          const HighlightIcon = item.highlightIcon

          return (
            <article
              key={item.titleKey}
              className="group relative flex h-[442px] flex-col items-center overflow-hidden rounded-[16px] border border-[#FFF0E7] px-[10px] pt-[30px] text-center shadow-[0_8px_24px_rgba(230,126,67,0.08)] transition-[transform,box-shadow] duration-300 hover:-translate-y-[4px] hover:shadow-[0_18px_38px_rgba(230,126,67,0.16)]"
              style={{
                background: 'var(--Linear, linear-gradient(0deg, #EEF5FF -0.11%, #FEF7F3 99.89%))',
              }}
            >
              <div className="absolute left-0 top-0 h-[88px] w-[88px] overflow-hidden" aria-hidden>
                <div
                  className="absolute left-[-31px] top-[15px] flex h-[32px] w-[116px] -rotate-45 items-center justify-center text-[16px] text-white"
                  style={{
                    background: 'var(--Style, linear-gradient(180deg, #299DF2 0%, #318BF8 100%))',
                  }}
                >
                  <LangText lngKey={item.badgeKey} />
                </div>
              </div>

              <img
                src={preFixImgUrl(item.image)}
                alt=""
                className="h-[178px] w-[178px] object-contain transition-transform duration-300 ease-out group-hover:scale-110"
                draggable={false}
              />

              <LangText
                lngKey={item.titleKey}
                className="mt-[11px] text-[32px] font-bold leading-[45px] text-[#328BF8] font-smiley-sans"
              />
              <LangText
                lngKey={item.descriptionKey}
                className="mt-[16px] whitespace-pre-line text-[16px] leading-[25px] text-[#666666]"
              />

              <div className="mt-[24px] flex h-[44px] items-center justify-center gap-[6px] rounded-full bg-[#fff] px-[14px] text-[#FB5C00] transition-colors duration-300">
                <HighlightIcon className="text-[24px]" />
                <LangText lngKey={item.highlightKey} className="text-[16px] font-medium text-[#979797]" />
              </div>
            </article>
          )
        })}
      </div>
    </div>
  </section>
)

export default ServiceFeatures
